import { render, staticRenderFns } from "./DeltaWidgetCell.vue?vue&type=template&id=0f7e4ae8&scoped=true"
import script from "./DeltaWidgetCell.vue?vue&type=script&lang=js"
export * from "./DeltaWidgetCell.vue?vue&type=script&lang=js"
import style0 from "./DeltaWidgetCell.vue?vue&type=style&index=0&id=0f7e4ae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7e4ae8",
  null
  
)

export default component.exports